import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Notification from '../messagerie_user/notification';
import { useParams } from 'react-router-dom';

function AffichageEquipe(props) {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [equipe, setEquipe] = useState();
    const { idEquipe } = useParams();
    const apiUrl = process.env.REACT_APP_API_URL;


    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
            try {
                const response = await axios.post(
                    `${apiUrl}/recherche/equipe-arbitre`,
                    {
                        id_equipe: idEquipe
                    },
                    {
                        withCredentials: true // Permet de transmettre les cookies avec la requête
                    }
                );
                setEquipe(response.data);
                setError(null);
                setIsLoading(false);
            } catch (error) {
                if (error.response) {
                    setError(error.response.data.message);
                } else {
                    setError(true);
                }
                setIsLoading(false);
            }
        };

        fetchData();
    }, [apiUrl, idEquipe]);

    if (isLoading) {
        return (
            <div className="centered-content">
                <img src="/img/logo.png" alt="Logo" className="centered-logo" />
                <br />
                <span className="loader"></span>
            </div>
        );
    }

    if (error) {
        return (
            <div id="alert-message" className="alert4">
                <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
            </div>
        );
    }

    return (
        <>
            {props.userData ? (
                <div className="main equipes">
                    <Notification userData={props.userData} />
                    {equipe && equipe.equipes && (
                        <div className="joueur equipe">
                            <div className="image7">
                                <img src={`${apiUrl}/image/equipe/${equipe.equipes[0].logo}`} alt="" width="100" height="100" />
                            </div>
                            <div className="nbr">{equipe.equipes[0].categorie}</div>
                            <div className="nom">
                                <a href={`/${props.type}/equipe/${equipe.equipes[0].id_equipe}`}>{equipe.equipes[0].nom}</a>
                            </div>
                            <br />
                        </div>
                    )}
                    <hr />
                    <h2>Staff</h2>
                    <div className="equipe2">
                        {equipe && equipe.coach.map((item, index) => (
                            <div key={index} className="joueur">
                                <div className="image6"></div>
                                <div className="nbr">T1</div>
                                <div className="nom">
                                    <a href={`/${props.type}/equipe/coach/${item.id_coach}`}>{item.nom} {item.prenom}</a>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr />
                    <h2>Gardien</h2>
                    <div className="equipe2">
                        {equipe && equipe.gardien.map((item, index) => (
                            <div key={index} className="joueur">
                                <div className="image"></div>
                                {item.numero !== null ? (
                                    <div className="nbr">{item.numero}</div>
                                ) : (
                                    <div className="nbr">X</div>
                                )}
                                <div className="nom">
                                    <a href={`/${props.type}/equipe/joueur/${item.id_joueur}`}>{item.nom} {item.prenom}</a>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr />
                    <h2>Défenseur</h2>
                    <div className="equipe2">
                        {equipe && equipe.defenseur.map((item, index) => (
                            <div key={index} className="joueur">
                                <div className="image3"></div>
                                {item.numero !== null ? (
                                    <div className="nbr">{item.numero}</div>
                                ) : (
                                    <div className="nbr">X</div>
                                )}
                                <div className="nom">
                                    <a href={`/${props.type}/equipe/joueur/${item.id_joueur}`}>{item.nom} {item.prenom}</a>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr />
                    <h2>Milieu</h2>
                    <div className="equipe2">
                        {equipe && equipe.milieu.map((item, index) => (
                            <div key={index} className="joueur">
                                <div className="image2"></div>
                                {item.numero !== null ? (
                                    <div className="nbr">{item.numero}</div>
                                ) : (
                                    <div className="nbr">X</div>
                                )}
                                <div className="nom">
                                    <a href={`/${props.type}/equipe/joueur/${item.id_joueur}`}>{item.nom} {item.prenom}</a>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr />
                    <h2>Attaquant</h2>
                    <div className="equipe2">
                        {equipe && equipe.attaquant.map((item, index) => (
                            <div key={index} className="joueur">
                                <div className="image4"></div>
                                {item.numero !== null ? (
                                    <div className="nbr">{item.numero}</div>
                                ) : (
                                    <div className="nbr">X</div>
                                )}
                                <div className="nom">
                                    <a href={`/${props.type}/equipe/joueur/${item.id_joueur}`}>{item.nom} {item.prenom}</a>
                                </div>
                            </div>
                        ))}
                    </div>
                    <hr />
                    <h2>Joueurs qui ne sont pas encore inscrits</h2>
                    <div className="equipe2">
                        {equipe && equipe.autre.map((item, index) => (
                            <div key={index} className="joueur">
                                <div className="image5"></div>
                                {item.numero !== null ? (
                                    <div className="nbr">{item.numero}</div>
                                ) : (
                                    <div className="nbr">X</div>
                                )}
                                <div className="nom">{item.nom} {item.prenom}</div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div id="alert-message" className="alert">
                    <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
                </div>
            )}
        </>
    );
}

export default AffichageEquipe;
